import React from 'react';
import BaseIcon from './BaseIcon';

class PointerSVG extends BaseIcon {
  render() {
    const { fillColor, height, width } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
        width={width}
        height={height}
        viewBox="0 0 36 48"
      >
        <path
          d="M18.645 47.764a.998.998 0 01-1.29 0C16.646 47.165 0 32.927 0 17.818 0 7.993 8.075 0 18 0s18 7.993 18 17.818c0 15.109-16.646 29.347-17.355 29.946zM18 2C9.178 2 2 9.096 2 17.818c0 12.571 12.932 25.061 16 27.846 3.066-2.787 16-15.287 16-27.846C34 9.096 26.822 2 18 2zm0 25c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7z"
          fill={fillColor}
          fillRule="evenodd"
        />
      </svg>
    );
  }
}

export default PointerSVG;
